import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Icons } from "../../assest/icons";
import { canManageAdminUsers, isDoctor, isMA } from '../../utils/roleHelper';

const iconStyle = { width: '22px', height: '22px', marginRight: '14px', flexShrink: 0 };

// All Patients — group of people
const IconAllPatients = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

// All Appointments — calendar
const IconAppointments = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
    <circle cx="12" cy="16" r="2"/>
  </svg>
);

// Admin Users — shield with person
const IconAdminUsers = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <circle cx="12" cy="10" r="2.5"/>
    <path d="M8.5 17a4.5 4.5 0 0 1 7 0"/>
  </svg>
);

// Portal Users — globe
const IconPortalUsers = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

// PCP Cases — medical folder with person
const IconPCPCases = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <path d="M9 13h6"/>
    <path d="M9 17h4"/>
    <circle cx="9" cy="9" r="1.5"/>
  </svg>
);

// Assessment and Plan — clipboard with check
const IconAssessment = () => (
  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
    <path d="M9 14l2 2 4-4"/>
  </svg>
);

function SideBarMenu() {
  const location = useLocation();
  const usernameTxt =  JSON.parse(localStorage.getItem('UserProfileAdmin'));

  const [UserName, setUserName] = useState(usernameTxt?.fullName || 'Admin');
  let navigate = useNavigate();
  const handleAllPatientsScreen = () => {
    navigate("/admin/allpatients");
  }
  const handledashboardScreen = () => {
    navigate("/admin/dashboard");
  }
  const handleAdminScreen = () => {
    navigate("/admin/adminusers");
  }
  const handleViewDocuments = () => {
    navigate("/admin/viewdocuments");
  }
  const handlePortalUsers = () => {
    navigate("/admin/portalusers");
  }
  const handlePCPCases = () => {
    navigate("/admin/pcp-cases");
  }
  return (
        <div className="containerDiv whiteBg sideBarMenu" >
          <div className="logDiv d-inline-block">
            <Link to="/admin/dashboard">
              <img src={Icons[0].logoIcon} className="logoImg companyLogo" alt="" />
            </Link>
          </div>

          <ul className=" w-100 d-inline-block sidenavList mt-2">
                {!isDoctor() && (
                <li className={`homeIconDiv ${location.pathname === '/admin/allpatients' ? 'active' : ''}`}  onClick={() => handleAllPatientsScreen()}>
                        <IconAllPatients />
                        All Patients
                </li>
                )}
                <li className={`homeIconDiv ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}  onClick={() => handledashboardScreen()}>
                        <IconAppointments />
                        All Appointments
                </li>
                {canManageAdminUsers() && (
                <li className={`homeIconDiv ${location.pathname === '/admin/adminusers' || location.pathname === '/admin/adduseradmin'  || location.pathname === '/admin/adminusersinfo' ? 'active' : ''}`}  onClick={() => handleAdminScreen()}>
                     <IconAdminUsers />
                        Admin Users
                </li>
                )}
                {canManageAdminUsers() && (
                <li className={`homeIconDiv ${location.pathname === '/admin/portalusers' ? 'active' : ''}`} onClick={() => handlePortalUsers()}>
                     <IconPortalUsers />
                        Portal Users
                </li>
                )}
                {isMA() && (
                <li className={`homeIconDiv ${location.pathname === '/admin/pcp-cases' ? 'active' : ''}`} onClick={() => handlePCPCases()}>
                    <IconPCPCases />
                    PCP Cases
                </li>
                )}
                <hr></hr>
                <li className={`homeIconDiv ${location.pathname === '/admin/viewdocuments' ? 'active' : ''}`} onClick={() => handleViewDocuments()}>
                    <IconAssessment />
                     Assessment and Plan
                </li>
            </ul>


        </div>
  )
}

export default SideBarMenu
